import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import styles from './index.module.less';
export const Textarea = ({ className, ...rest }) => {
    return _jsx("textarea", { className: classnames(styles.textarea, className), ...rest });
};
